import numeral from 'numeral'

export default ({ reading: { value } }) => numeral(value).format('0.00')
